<template>
  <div id="pageProperty">
    <v-container grid-list-md fluid>
      <div class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
          v-if="load"
        ></v-progress-circular>
      </div>

      <v-form v-if="!load" ref="form" v-model="form.valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card>
              <v-card-text>
                <h2 class="title">1. Informações da Propriedade</h2>

                <v-layout row wrap>
                  <v-flex md6 xs12>
                    <v-text-field
                      v-model="property.name"
                      :counter="255"
                      :rules="returnRules('Nome')"
                      label="Nome Fantasia (*)"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      v-model="property.name_official"
                      :counter="255"
                      :rules="returnRulesMaxCharacters('Nome oficial')"
                      label="Nome no Cadastro de Orgãos Oficiais"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg6 md12 xs12>
                    <v-textarea
                      :no-resize="true"
                      :clearable="true"
                      v-model="property.description"
                      label="Descrição (Essa informação será pública, poderá ser vista por outras pessoas.)"
                    ></v-textarea>
                  </v-flex>
                  <v-row justify="center">
                    <v-col>
                      <v-row justify="center">
                        <v-col md6 xs6>
                          <v-select
                            v-model="property.status"
                            :items="status"
                            item-value="value"
                            item-text="name"
                            label="Staus"
                            outlined
                          ></v-select>
                        </v-col>
                        <v-col md6 xs6>
                          <!-- <v-select
                            v-model="property.user_id"
                            :rules="form.user.rules"
                            :items="users"
                            item-value="id"
                            item-text="name"
                            label="Proprietário (*)"
                            outlined
                            required
                          ></v-select>-->

                          <v-autocomplete
                            v-model="property.user_id"
                            :rules="form.user.rules"
                            :items="users"
                            item-value="id"
                            hide-details
                            hide-no-data
                            hide-selected
                            item-text="name"
                            label="Proprietário (*)"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <v-card>
              <v-card-text>
                <h2 class="title">2. Identificação em Órgãos</h2>
                <v-layout row wrap>
                  <v-flex md6 xs12>
                    <v-text-field
                      v-model="property.nr_car"
                      :counter="255"
                      :error="this.form.nr_car.error"
                      :error-messages="this.form.nr_car.message"
                      :rules="returnRulesMaxCharacters('CAR')"
                      label="CAR (Cadastro Ambiental Rural)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      v-model="property.nr_incra"
                      label="INCRA (Código do Imovel Rural)"
                    ></v-text-field>
                  </v-flex>

                  <v-flex md6 xs12>
                    <v-text-field
                      v-model="property.nr_nirf"
                      label="NIRF (Inscrição na Receita Federal)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      v-model="property.nr_ccir"
                      label="CCIR (Certificado de Cadastro de Imóvel Rural)"
                    ></v-text-field>
                  </v-flex>

                  <v-flex md6 xs12>
                    <v-text-field
                      v-model="property.perimeter_source"
                      label="Origem dos Docs que contem o Perímetro"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      v-model="property.nr_lar"
                      label="Número LAR/LAU/LARPR Ativo"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <v-card>
              <v-card-text>
                <h2 class="title">3. Produtores</h2>
                <v-layout row wrap>
                  <v-flex
                    xs12
                    v-for="(explorer, index) in property.explorers"
                    :key="'explorer' + index"
                  >
                    <v-card>
                      <v-card-text>
                        <div>
                          Produtor {{ index + 1 }}
                          <v-btn
                            text
                            icon
                            color="pink"
                            small
                            @click="deleteExplorerRequest(index)"
                          >
                            <v-icon>fa-trash</v-icon>
                          </v-btn>
                        </div>

                        <app-confirm-modal
                          message="Você tem certeza que quer deletar?"
                          :dialog="dialogDeleteExplorer"
                          modalType="error"
                          v-on:choose="deleteExplorer(index)"
                        />

                        <v-row v-if="explorer.exits">
                          <v-col>
                            <v-alert type="error"
                              >Já existe um produtor com os dados
                              informados</v-alert
                            >
                          </v-col>
                        </v-row>
                        <v-layout row wrap>
                          <v-flex md6 xs12>
                            <v-text-field
                              type="text"
                              @keydown="resetCpfError(index)"
                              v-model="explorer.document_number"
                              :rules="returnRules('CPF/CNPJ')"
                              :error="explorer.error || false"
                              :error-messages="explorer.message || ''"
                              label="CPF/CNPJ (*)"
                            ></v-text-field>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-text-field
                              v-model="explorer.name"
                              :counter="255"
                              :rules="returnRules('Nome')"
                              label="Nome (*)"
                            ></v-text-field>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-text-field
                              v-model="explorer.establishment_code"
                              v-on:keyup="
                                deleteError(explorer, 'establishment_code')
                              "
                              :counter="255"
                              :rules="returnRules('Código do estabelicimento')"
                              label="Código do estabelecimento (*)"
                            ></v-text-field>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-text-field
                              v-model="explorer.ie"
                              v-on:keyup="deleteError(explorer, 'ie')"
                              :counter="255"
                              :rules="returnRules('Inscrição Estadual')"
                              label="IE (Inscrição Estadual) (*)"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs12>
                    <v-btn color="primary" @click="addExplorer" small>
                      <span>
                        <v-icon class="mr-3">fa-plus</v-icon>Adicionar Produtor
                      </span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <v-card>
              <v-card-text>
                <h2 class="title">4. Contatos</h2>
                <v-layout row wrap>
                  <v-flex
                    xs12
                    v-for="(contact, index) in property.contacts"
                    :key="'contact' + index"
                  >
                    <v-card>
                      <v-card-text>
                        <div>
                          Contato {{ index + 1 }}
                          <v-btn
                            text
                            icon
                            color="pink"
                            small
                            @click="deleteContact(index)"
                          >
                            <v-icon>fa-trash</v-icon>
                          </v-btn>
                        </div>

                        <app-confirm-modal
                          message="Você tem certeza que quer deletar?"
                          :dialog="dialogDeleteContact"
                          modalType="error"
                          v-on:choose="deleteContact(index)"
                        />

                        <v-layout row wrap>
                          <v-flex md3 xs12>
                            <v-text-field
                              v-model="contact.name"
                              :counter="255"
                              :rules="returnRules('Nome')"
                              label="Nome (*)"
                            ></v-text-field>
                          </v-flex>
                          <v-flex md3 xs12>
                            <v-text-field
                              v-model="contact.position"
                              label="Cargo"
                            ></v-text-field>
                          </v-flex>
                          <v-flex md3 xs12>
                            <v-text-field
                              v-model="contact.phone"
                              v-mask="'+## (##) #####-####'"
                              :rules="form.phone.rules"
                              label="Telefone"
                            ></v-text-field>
                          </v-flex>
                          <v-flex md3 xs12>
                            <v-text-field
                              v-model="contact.email"
                              :rules="form.email.rules"
                              label="E-mail"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs12>
                    <v-btn color="primary" @click="addContact" small>
                      <v-icon class="mr-3">fa-plus</v-icon>Adicioar Contato
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <v-card>
              <v-card-text>
                <h2 class="title">5. Localização</h2>
                <v-layout row wrap>
                  <v-flex md6 xs12>
                    <v-select
                      v-model="state_id"
                      :items="states"
                      item-value="id"
                      item-text="state_name"
                      label="Estado"
                      v-on:change="getCities"
                    ></v-select>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-select
                      v-model="property.address_city_id"
                      :items="cities"
                      item-value="id"
                      item-text="name"
                      label="Cidade"
                    ></v-select>
                  </v-flex>

                  <v-flex md6 xs12>
                    <v-text-field
                      v-model="property.address_latitude"
                      label="Latitude"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      v-model="property.address_longitude"
                      label="Longitude"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-btn
          :disabled="!form.valid"
          :loading="this.loading"
          color="success"
          class="mr-4"
          @click="validate"
          >Salvar</v-btn
        >
      </v-form>

      <v-snackbar v-model="snackbar.open" :color="snackbar.color">
        {{ snackbar.message }}
        <v-btn text @click="snackbar.open = false">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-snackbar>

      <v-dialog persistent v-model="propertyDialog" max-width="350px">
        <v-card>
          <v-card-title class="green white--text">
            Editar Propriedade
          </v-card-title>
          <v-card-text class="pt-5 black--text font-weight-medium title">
            Propriedade salva com sucesso!
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              depressed
              @click="goPropertyList"
            >
              Ok
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import appApi from "../../plugins/api";
import ConfirmModal from "../../components/ConfirmModal";
import moment from "moment";

export default {
  components: {
    "app-confirm-modal": ConfirmModal
  },
  data: function() {
    return {
      dialogDeleteExplorer: false,
      dialogDeleteContact: false,
      propertyDialog: false,
      load: false,
      loading: false,
      snackbar: {
        open: false,
        message: "",
        color: "success"
      },
      property: {
        name: "",
        name_official: "",
        description: "",
        status: 1,

        nr_car: "",
        nr_incra: "",
        nr_nirf: "",
        nr_ccir: "",
        perimeter_source: "",
        nr_lar: "",

        user_id: "",

        address_city_id: "",
        address_latitude: "",
        address_longitude: "",

        explorers: [
          {
            name: "",
            document_number: "",
            establishment_code: "",
            ie: ""
          }
        ],

        contacts: [
          {
            name: "",
            position: "",
            phone: "",
            email: "",
            default: false
          }
        ]
      },
      form: {
        valid: true,

        nr_car: {
          error: false
        },

        user: {
          rules: [v => !!v || "Proprietário é obrigatório"]
        },

        email: {
          rules: [
            v =>
              !v ||
              v.length == 0 ||
              /.+@.+\..+/.test(v) ||
              "E-mail não é válido"
          ]
        },
        phone: {
          rules: [
            v =>
              !v ||
              v.length == 0 ||
              v.replace(/\D/g, "").length == 13 ||
              "Telefone não é válido"
          ]
        },

        explorer: {
          rules: {
            cpf: [
              v => !!v || "CPF é obrigatório",
              v =>
                v.length < 256 ||
                "CPF tem quer ser menor ou igual as 255 caracteres"
            ]
          },
          error: false,
          message: ""
        }
      },
      status: [
        { name: "Ativa", value: 1 },
        { name: "Inativa", value: 0 }
      ],
      state_id: null,
      states: [],
      users: [],
      cities: [],
      countExplorers: 0,
      countErrorExplorers: 0
    };
  },

  computed: {},

  mounted: function() {
    window.scrollTo(0, 0);
    if (this.$route.params.id) {
      appApi.getProperty(this.$route.params.id).then(result => {
        this.property = { ...result.data, user_id: result.data.user.id };
        this.load = false;
        if (this.property.address_city_id) {
          appApi.getAddressCity(this.property.city.id).then(result => {
            this.state_id = result.data.state_id;
            this.getCities();
          });
        }
      });
    } else {
      this.load = false;
    }

    appApi.getAddressStates().then(result => {
      this.states = result.data;
    });

    appApi.getUsers().then(({ data: result }) => {
      this.users = result.data;
    });
  },

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.saveProperty();
      }
    },
    saveProperty() {
      this.loading = true;
      if (this.property.id) {
        appApi
          .putProperty(this.property.id, this.property)
          .then(result => {
            this.saveContacts();
            this.saveExplorers();
          })
          .catch(e => {
            this.saveError(e);
          });
      } else {
        appApi
          .postProperty(this.property)
          .then(result => {
            this.property.id = result.data.id;
            this.saveContacts();
            this.saveExplorers();
            setTimeout(() => {
              this.$router.push({
                name: "Property",
                params: { id: result.data.id }
              });
            }, 2000);
          })
          .catch(e => {
            this.saveError(e);
          });
      }
      this.loading = false;
    },
    saveContacts() {
      if (this.property.contacts && this.property.contacts.length > 0) {
        this.property.contacts.forEach(contact => {
          if (!contact.id) {
            contact.property_id = this.property.id;
            appApi.postPropertyContact(contact).then(result => {
              contact["id"] = result.data.id;
            });
          } else {
            appApi.putPropertyContact(contact.id, contact);
          }
        });
      }
    },
    saveExplorers() {
      this.countExplorers = 0;
      this.countErrorExplorers = 0;
      this.loading = true;
      if (this.property.explorers && this.property.explorers.length > 0) {
        this.property.explorers.forEach((explorer, idx) => {
          delete explorer.exits;
          delete explorer.error;
          if (!explorer.id) {
            explorer.property_id = this.property.id;
            appApi
              .postExplorer(explorer)
              .then(result => {
                explorer["id"] = result.data.id;
              })
              .catch(err => {
                this.countErrorExplorers++;
                this.errorExplorSave(err, explorer, idx);
              })
              .finally(() => {
                this.countExplorers++;
                this.alertSaveSucess();
              });
          } else {
            appApi
              .putExplorer(explorer.id, explorer)
              .catch(err => {
                this.countErrorExplorers++;
                this.errorExplorSave(err, explorer, idx);
              })
              .finally(() => {
                this.countExplorers++;
                this.alertSaveSucess();
              });
          }
        });
      } else {
        this.alertSaveSucess();
      }
    },
    alertSaveSucess() {
      if (this.countExplorers == this.property.explorers.length) {
        this.loading = false;
        if (this.countErrorExplorers == 0) {
          this.propertyDialog = true;
        } else {
          this.snackbar.open = true;
          this.snackbar.message = "Erro ao salvar produtor";
          this.snackbar.color = "error";
        }
      }
    },
    saveError(err) {
      this.loading = false;
      this.snackbar.open = true;
      this.snackbar.message = "Não foi possível salvar, verifique os erros.";
      this.snackbar.color = "error";
      if (err.response && err.response.status == 400) {
        this.property.errors = {};
        err.response.data.forEach(element => {
          this.form[element.field].error = true;
          this.form[element.field].message = "Valor inválido";
          if (element.field === "nr_car") {
            this.form[element.field].message = "CAR precisa ser único";
          }
        });
      }
    },
    errorExplorSave(err, explorer, idx) {
      if (err.response && err.response.status == 400) {
        this.property.explorers[idx].error = {};
        err.response.data.forEach(element => {
          if (element.validation == "existExplorer") {
            this.property.explorers[idx].exits = true;
            console.log(true);
          } else {
            this.property.explorers[idx].error = true;
            this.property.explorers[idx].message = "Valor inválido";
          }
        });
      }
    },
    addExplorer() {
      if (!("explorers" in this.property) || !this.property.explorers) {
        Vue.set(this.property, "explorers", []);
      }
      this.property.explorers.push({
        name: "",
        document_number: "",
        establishment_code: "",
        ie: ""
      });
    },
    deleteExplorer(index) {
      const { id } = this.property.explorers[index];
      appApi.destroyExplorer(id);
      delete this.property.explorers.splice(index, 1);
    },

    deleteExplorerRequest(index) {
      if (!this.property.explorers[index].id) {
        delete this.property.explorers.splice(index, 1);
        return;
      }
      this.dialogDeleteExplorer = true;
    },

    addContact() {
      if (!("contacts" in this.property) || !this.property.contacts) {
        Vue.set(this.property, "contacts", []);
      }
      this.property.contacts.push({
        name: "",
        document_number: "",
        establishment_code: "",
        ie: ""
      });
    },
    deleteContact(index) {
      const { id } = this.property.contacts[index];
      appApi.destroyPropertyContact(id);
      delete this.property.contacts.splice(index, 1);
    },

    deleteContactRequest(index) {
      if (this.property.contacts[index].id) {
        delete this.property.contacts.splice(index, 1);
        return;
      }
      this.dialogDeleteContact = true;
    },

    getCities() {
      appApi.getAddressCities({ state_id: this.state_id }).then(result => {
        this.cities = result.data;
        console.log(this.cities);
      });
    },

    deleteError(explorer, field) {
      if (explorer.error && explorer.error[field]) {
        delete explorer.error[field];
      }
    },

    returnRules(field) {
      return [
        v => !!v || `${field} é obrigatório`,
        v =>
          v.length < 256 ||
          `${field} tem quer ser menor ou igual as 255 caracteres`
      ];
    },

    returnRulesMaxCharacters(field) {
      return 
        v =>
          v.length < 256 ||
          `${field} tem quer ser menor ou igual as 255 caracteres`;
    },

    resetCpfError(index) {
      if (this.property.explorers[index].error) {
        this.property.explorers[index].error = false;
        this.property.explorers[index].message = "";
      }
    },

    goPropertyList() {
      this.$router.push('/propriedades');
    }
  }
};
</script>

<style scoped lang="css"></style>
